import { useState } from 'react';
import { $t } from 'hooks/i18n';
import { Avatar } from 'primereact/avatar';
import { Button } from 'primereact/button';
import { DataSource } from 'components/DataSource';
import { ProgressBar } from 'primereact/progressbar';
import { Title } from 'components/Title';

export default function CollectionPage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="CollectionPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title={$t('collection')}   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <section className="page-section mb-3" >
                    <div className="container-fluid">
                        <div className="grid ">
                            <div className="col-sm-4 col-md-4 col-12 sm:col-1 lg:col-3 md:col-3 comp-grid" >
                                <div className="">
                                    <DataSource   apiPath="components_data/option_agent_target" firstRecord={true} showLoading={false}>
                                        {
                                        ({ response, loading, reload }) => 
                                        <>
                                        <div >
                                            <div className="overdue-card relative">
                                                {/* Refresh Button */}
                                                <div className="overdue-refresh">
                                                    <Button
                                                    className="overdue-refresh-btn"
                                                    onClick={() => reload()}
                                                    icon="pi pi-refresh"
                                                    tooltip="Refresh"
                                                    tooltipOptions={{ position: 'left' }}
                                                    />
                                                </div>
                                                <div className="flex align-items-center gap-3">
                                                    {/* Icon */}
                                                    <div className="overdue-icon-wrapper">
                                                        <Avatar
                                                            icon="pi pi-clone"
                                                            size="large"
                                                            className="overdue-icon"
                                                            />
                                                        </div>
                                                        {/* Content */}
                                                        <div className="flex-1">
                                                            <div className="overdue-title">
                                                                Today Target Amount
                                                            </div>
                                                            <div className="overdue-subtitle">
                                                                Amount to Collect
                                                            </div>
                                                            {loading ? (
                                                            <div className="overdue-progress">
                                                                <ProgressBar
                                                                mode="indeterminate"
                                                                style={{ height: '5px' }}
                                                                />
                                                            </div>
                                                            ) : (
                                                            <div className="overdue-value">
                                                                {response
                                                                ? Number(response.target || 0).toLocaleString()
                                                                : '0'}
                                                            </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {/* Bottom accent */}
                                                    <div className="overdue-accent"></div>
                                                </div>
                                            </div>
                                            </>
                                            }
                                        </DataSource>
                                    </div>
                                </div>
                                <div className="col-sm-4 col-md-4 col-12 sm:col-1 lg:col-3 md:col-3 comp-grid" >
                                    <div className="">
                                        <DataSource   apiPath="components_data/option_agent_collected" firstRecord={true} showLoading={false}>
                                            {
                                            ({ response, loading, reload }) => 
                                            <>
                                            <div >
                                                <div className="overdue-card relative">
                                                    {/* Refresh Button */}
                                                    <div className="overdue-refresh">
                                                        <Button
                                                        className="overdue-refresh-btn"
                                                        onClick={() => reload()}
                                                        icon="pi pi-refresh"
                                                        tooltip="Refresh"
                                                        tooltipOptions={{ position: 'left' }}
                                                        />
                                                    </div>
                                                    <div className="flex align-items-center gap-3">
                                                        {/* Icon */}
                                                        <div className="overdue-icon-wrapper">
                                                            <Avatar
                                                                icon="pi pi-building"
                                                                size="large"
                                                                className="overdue-icon"
                                                                />
                                                            </div>
                                                            {/* Content */}
                                                            <div className="flex-1">
                                                                <div className="overdue-title">
                                                                    Today Amount Collected
                                                                </div>
                                                                <div className="overdue-subtitle">
                                                                    Accounts requiring attention
                                                                </div>
                                                                {loading ? (
                                                                <div className="overdue-progress">
                                                                    <ProgressBar
                                                                    mode="indeterminate"
                                                                    style={{ height: '5px' }}
                                                                    />
                                                                </div>
                                                                ) : (
                                                                <div className="overdue-value">
                                                                    {response
                                                                    ? Number(response.collected|| 0).toLocaleString()
                                                                    : '0'}
                                                                </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        {/* Bottom accent */}
                                                        <div className="overdue-accent"></div>
                                                    </div>
                                                </div>
                                                </>
                                                }
                                            </DataSource>
                                        </div>
                                    </div>
                                    <div className="col-sm-4 col-md-4 col-12 sm:col-1 lg:col-3 md:col-3 comp-grid" >
                                        <div className="">
                                            <DataSource   apiPath="components_data/option_agent_pending" firstRecord={true} showLoading={false}>
                                                {
                                                ({ response, loading, reload }) => 
                                                <>
                                                <div >
                                                    <div className="overdue-card relative">
                                                        {/* Refresh Button */}
                                                        <div className="overdue-refresh">
                                                            <Button
                                                            className="overdue-refresh-btn"
                                                            onClick={() => reload()}
                                                            icon="pi pi-refresh"
                                                            tooltip="Refresh"
                                                            tooltipOptions={{ position: 'left' }}
                                                            />
                                                        </div>
                                                        <div className="flex align-items-center gap-3">
                                                            {/* Icon */}
                                                            <div className="overdue-icon-wrapper">
                                                                <Avatar
                                                                    icon="pi pi-file-edit"
                                                                    size="large"
                                                                    className="overdue-icon"
                                                                    />
                                                                </div>
                                                                {/* Content */}
                                                                <div className="flex-1">
                                                                    <div className="overdue-title">
                                                                        Today Pending Amount
                                                                    </div>
                                                                    <div className="overdue-subtitle">
                                                                        Accounts requiring attention
                                                                    </div>
                                                                    {loading ? (
                                                                    <div className="overdue-progress">
                                                                        <ProgressBar
                                                                        mode="indeterminate"
                                                                        style={{ height: '5px' }}
                                                                        />
                                                                    </div>
                                                                    ) : (
                                                                    <div className="overdue-value">
                                                                        {response
                                                                        ? Number(response.pending || 0).toLocaleString()
                                                                        : '0'}
                                                                    </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            {/* Bottom accent */}
                                                            <div className="overdue-accent"></div>
                                                        </div>
                                                    </div>
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                        <div className="col-sm-4 col-md-4 col-12 sm:col-1 lg:col-3 md:col-3 comp-grid" >
                                            <div className="">
                                                <DataSource   apiPath="components_data/option_agent_overdue" firstRecord={true} showLoading={false}>
                                                    {
                                                    ({ response, loading, reload }) => 
                                                    <>
                                                    <div >
                                                        <div className="overdue-card relative">
                                                            {/* Refresh Button */}
                                                            <div className="overdue-refresh">
                                                                <Button
                                                                className="overdue-refresh-btn"
                                                                onClick={() => reload()}
                                                                icon="pi pi-refresh"
                                                                tooltip="Refresh"
                                                                tooltipOptions={{ position: 'left' }}
                                                                />
                                                            </div>
                                                            <div className="flex align-items-center gap-3">
                                                                {/* Icon */}
                                                                <div className="overdue-icon-wrapper">
                                                                    <Avatar
                                                                        icon="pi pi-calculator"
                                                                        size="large"
                                                                        className="overdue-icon"
                                                                        />
                                                                    </div>
                                                                    {/* Content */}
                                                                    <div className="flex-1">
                                                                        <div className="overdue-title">
                                                                            Overdue Cases
                                                                        </div>
                                                                        <div className="overdue-subtitle">
                                                                            Overdue Amount:
                                                                            {response
                                                                            ? Number(response.odamt || 0).toLocaleString()
                                                                            : '0'}
                                                                        </div>
                                                                        {loading ? (
                                                                        <div className="overdue-progress">
                                                                            <ProgressBar
                                                                            mode="indeterminate"
                                                                            style={{ height: '5px' }}
                                                                            />
                                                                        </div>
                                                                        ) : (
                                                                        <div className="overdue-value">
                                                                            {response
                                                                            ? Number(response.overdue || 0).toLocaleString()
                                                                            : '0'}
                                                                        </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                {/* Bottom accent */}
                                                                <div className="overdue-accent"></div>
                                                            </div>
                                                        </div>
                                                        </>
                                                        }
                                                    </DataSource>
                                                </div>
                                            </div>
                                            <div className="col-sm-4 col-md-4 col-12 sm:col-1 lg:col-3 md:col-3 comp-grid" >
                                                <div className="">
                                                    <DataSource   apiPath="components_data/option_agent_visit" firstRecord={true} showLoading={false}>
                                                        {
                                                        ({ response, loading, reload }) => 
                                                        <>
                                                        <div >
                                                            <div className="overdue-card relative">
                                                                {/* Refresh Button */}
                                                                <div className="overdue-refresh">
                                                                    <Button
                                                                    className="overdue-refresh-btn"
                                                                    onClick={() => reload()}
                                                                    icon="pi pi-refresh"
                                                                    tooltip="Refresh"
                                                                    tooltipOptions={{ position: 'left' }}
                                                                    />
                                                                </div>
                                                                <div className="flex align-items-center gap-3">
                                                                    {/* Icon */}
                                                                    <div className="overdue-icon-wrapper">
                                                                        <Avatar
                                                                            icon="pi pi-calendar"
                                                                            size="large"
                                                                            className="overdue-icon"
                                                                            />
                                                                        </div>
                                                                        {/* Content */}
                                                                        <div className="flex-1">
                                                                            <div className="overdue-title">
                                                                                No of Lonee to Visit
                                                                            </div>
                                                                            <div className="overdue-subtitle">
                                                                                Accounts requiring attention
                                                                            </div>
                                                                            {loading ? (
                                                                            <div className="overdue-progress">
                                                                                <ProgressBar
                                                                                mode="indeterminate"
                                                                                style={{ height: '5px' }}
                                                                                />
                                                                            </div>
                                                                            ) : (
                                                                            <div className="overdue-value">
                                                                                {response
                                                                                ? Number(response.visit || 0).toLocaleString()
                                                                                : '0'}
                                                                            </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    {/* Bottom accent */}
                                                                    <div className="overdue-accent"></div>
                                                                </div>
                                                            </div>
                                                            </>
                                                            }
                                                        </DataSource>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </section>
		</main>
	);
}
